import React from "react";
import dayjs from "dayjs";
import withPurchase from "../../../../hoc/withPurchase";
import { HeaderPhoneUi } from "../../../../components/ui";
import { formattedNumber } from "../../../../utils/formattedNumber";

const Result = ({ type, state, mobile }) => {
  return (
    <>
      <img
        src={require(`../../../../assets/img/generator/bank/sberbank/completed/sberbank-${type}-${state.theme}.png`)}
        className="img-fluid img-thumbnail"
        width="100%"
        alt=""
      />

      <HeaderPhoneUi type={type} mode={state.theme} {...mobile} />

      <p className="amount">
        {formattedNumber(state.amount || 0.0).replace(/,/, ".")} ₽
      </p>
      <p className="sender">{state.sender || "____________________"}</p>
      <p className="last-card-debit">{state.lastCardDebit || "0000"}</p>
      <p className="last-card-enroll">{state.lastCardEnroll || "0000"}</p>
      <p className="date">
        {state.fullDate
          ? dayjs(state.fullDate).format("DD.MM.YYYY HH:mm")
          : "01.01.2024 00:00"}
      </p>
    </>
  );
};

export default withPurchase(Result, {
  className: `result-img sberbank completed`,
});
